import { FC } from "react";

import { PercentIndicatorCircle } from "components/PercentIndicatorCircle/PercentIndicatorCircle";

interface Props {
  percent: number;
  size: number;
  strokeWidth: number;
}

export const KpiPercentIndicatorCircle: FC<Props> = ({
  percent,
  size,
  strokeWidth
}): JSX.Element => {
  let displayText = "-";
  let fgcolor = "hsl(33, 96%, 54%)";

  if (percent >= 100) {
    // TODO: use the theme color
    fgcolor = "hsl(130, 61%, 39%)";
  }

  displayText = `${Math.round(percent)}%`;

  return (
    <PercentIndicatorCircle
      bgcolor="hsl(0, 0%, 56%)"
      fgcolor={fgcolor}
      displayText={displayText}
      percent={percent}
      size={size}
      strokeWidth={strokeWidth}
    />
  );
};
